import { IsEnum, IsOptional } from 'class-validator';

import { PaymentTypeEnum } from '@onArte/shared/database/enums';

export class CartUpdateFinishModel {
  @IsEnum(PaymentTypeEnum)
  public paymentType?: PaymentTypeEnum;

  @IsOptional()
  public creditCardId?: string;
  
  @IsOptional()
  public promotionCode?: string;

  @IsOptional()
  public commentToOrder?: string;

  constructor(
    paymentType?: PaymentTypeEnum,
    creditCardId?: string,
    promotionCode?: string,
    commentToOrder?: string
  ) {
    this.paymentType = paymentType;
    this.creditCardId = creditCardId;
    this.promotionCode = promotionCode;
    this.commentToOrder = commentToOrder;
  }
}
